import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { getIdentityTimezone } from 'store/entities/identity/selectors'
import Timezone from './Timezone'

const mapStateToProps = createStructuredSelector({
  identityTimezone: getIdentityTimezone,
})

export default connect(mapStateToProps)(Timezone)
